import { render, staticRenderFns } from "./BillAPChange.vue?vue&type=template&id=69772c42"
import script from "./BillAPChange.vue?vue&type=script&lang=js"
export * from "./BillAPChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports